import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';


@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})

export class LoginComponent implements OnInit {

    userName: string;
    password: string;
    message: string = null;
    loading = false;

    constructor(private router: Router, private userService: CustomerService) {
    }

    ngOnInit(): void {

    }

    signIn( s: string ): void {
        this.loading = true;
        this.userService.login(this.userName, this.password).then(res => {
            if (res.status === 200) {
                setTimeout(() => {
                    this.router.navigate(['home']);
                }, 500);
            } else {
                let e = JSON.parse(res._body);
                this.message = 'Failed:' + e.error_description;
            }
            this.loading = false;
        }, (error) => {
            const body = JSON.parse(error._body);
            this.message = 'Failed:' + body.error_description;
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Login/login.component.ts